import React, { FC, Fragment, ReactElement } from 'react';
import { UseQueryResult } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { GetFeedQuery } from 'api';
import { Loaders } from 'components';

import { GridSectionTitle, LargeSection, MediumSection } from 'features/feed';

interface Props {
  emptyState: ReactElement;
  timelineQueryResult: UseQueryResult<GetFeedQuery, Error>;
}

const GridTimeline: FC<Props> = ({ emptyState, timelineQueryResult }) => {
  const { t } = useTranslation();
  const { data, isLoading } = timelineQueryResult;

  let layout = null;
  const results = data?.getFeed?.results || [];

  if (isLoading) {
    return <Loaders.Feed />;
  }

  function getResults(indexes: number[]) {
    return indexes.map(index => results[index]);
  }

  function twoResults() {
    return (
      <Fragment>
        <GridSectionTitle title={t('common:featured')} />
        <LargeSection results={getResults([1])} />
      </Fragment>
    );
  }

  function threeResults() {
    return (
      <Fragment>
        <GridSectionTitle title={t('common:featured')} />
        <LargeSection results={getResults([1])} />
        <Box marginTop={5}>
          <LargeSection results={getResults([2])} />
        </Box>
      </Fragment>
    );
  }

  function fourResults() {
    return (
      <Fragment>
        <GridSectionTitle title={t('common:featured')} />
        <LargeSection results={getResults([1])} />
        <Box marginTop={2}>
          <MediumSection results={getResults([2, 3])} />
        </Box>
      </Fragment>
    );
  }

  function fiveResults() {
    return (
      <Fragment>
        <GridSectionTitle title={t('common:featured')} />
        <MediumSection results={getResults([1, 2])} />
        <Box marginTop={2}>
          <MediumSection results={getResults([3, 4])} />
        </Box>
      </Fragment>
    );
  }

  switch (results.length) {
    case 0:
      return emptyState;
    case 1:
      return <LargeSection results={getResults([0])} />;
    case 2:
      layout = twoResults();
      break;
    case 3:
      layout = threeResults();
      break;
    case 4:
      layout = fourResults();
      break;
    case 5:
    default:
      layout = fiveResults();
      break;
  }

  return (
    <Fragment>
      <LargeSection results={getResults([0])} />
      {layout}
    </Fragment>
  );
};

export default GridTimeline;
